module.exports = __webpack_public_path__ + "static/img/陈双明B.d68b4889.png";